<template>
	<div class="flex flex-row flex-wrap">
		<div class="col-12 xl:col-12">
			<div class="card">

				<!-- Services header with edit lock/unlock -->
				<div class="grid">
					<!-- Title -->
					<div class="col"><h4>Service Definitions</h4></div>

					<!-- Lock/Unlock-->
					<div class="col-fixed align-self-end align-items-center">
						<a @click="editMode=!editMode;editModeChanged()">
							<i v-if="editMode" class="pi pi-lock-open" style="font-size: 1.5rem" />
							<i v-if="!editMode" class="pi pi-lock" style="font-size: 1.5rem" />
						</a>
					</div>
				</div>

				<!-- Filter text box -->
				<div style="margin:10px;" class="flex">
					<div class="w-100pc p-input-icon-left p-input-icon-right">
						<i class="pi pi-home" />
						<InputText v-model="serviceListFilter" placeholder="Service keyword filter.." />
						<i class="pi pi-search" />
					</div>
					<div class="align-items-center" v-if="editMode">
						<Button @click="showAddService = true" class="ml-1 mr-1" icon="pi pi-plus" />
					</div>
				</div>

				<!-- Filters-->
				<div class="grid pt-2 ml-2 search-panel">

					<!-- Active/Inactive-->
					<div class="flex align-items-center">
						<InputSwitch v-model="activeServicesOnly" @change="loadServices" />
						<span class="ml-1">Only active</span>
					</div>

					<!-- Only services in use -->
					<div class="flex align-items-center ml-4">
						<InputSwitch v-model="onlyServicesInUse" @change="loadServices" />
						<span class="ml-1">Only services in use</span>
					</div>

					<!-- Only parent services -->
					<div class="flex align-items-center ml-4">
						<InputSwitch v-model="onlyParentServices" @change="loadServices" />
						<span class="ml-1">Only parent services</span>
					</div>
				</div>

				<!-- Services Table-->
				<div style="padding:10px;width:100%;padding-top:0px;">
					<DataView :value="filteredServices"
							  datakey="serviceId"
							  :paginator="true"
							  :rows="10"
							  :scrollable="true"
							  stripedRows
							  class="p-datatable-sm property-service-table"
							  :paginatorTemplate="paginatorTemplate"
							  :rowsPerPageOptions="[10,20,50,100,200]"
							  responsiveLayout="scroll"
							  :alwaysShowPaginator="false"
							  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

						<template #header>
							<div class="col-12">
								<div class="grid flex-nowrap">
									<div class="col">Service name</div>
									<div class="col-1 hidden xl:block">Building act</div>
									<div class="col-1 hidden xl:block">Interval months</div>
									<div class="col-1 hidden xl:block">Full service price</div>
									<div class="col-1 hidden xl:block">Audit price</div>
									<div class="col-1 hidden xl:block">Council codes</div>
									<div class="text-center col-fixed" style="width:100px;">Active</div>
								</div>
							</div>
						</template>

						<template #list="{data}">
							<div class="col-12 property-service-item hover-row">
								<div :class="['grid flex-nowrap', { childNode: data.parentServiceId != null, parentNode: data.parentServiceId == null }]">
									<div class="col service-name compass-red">
										{{data.serviceName}}
										<a @click="serviceNameEdit(data)" v-if="editMode">
											<i class="pi pi-pencil" />
										</a>
										<div style="margin-left:50px;margin-top:4px;" v-if="editMode"></div>
									</div>
									<div class="col-1 hidden xl:block">
										<span v-if="!editMode">{{data.buildingAct}}</span>
										<InputText v-if="editMode" v-model="data.buildingAct"></InputText>
									</div>
									<div class="col-1 hidden xl:block">
										<span v-if="!editMode">{{data.intervalMonths}}</span>
										<Dropdown v-if="editMode" v-model="data.intervalMonths" :options="serviceIntervalOptions" class="flex" />
									</div>
									<div class="col-1 hidden xl:block">
										<span v-if="!editMode && data.fullServicePrice != null">${{data.fullServicePrice}}</span>
										<InputNumber mode="decimal" :minFractionDigits="2" v-if="editMode" v-model="data.fullServicePrice"></InputNumber>
									</div>
									<div class="col-1 hidden xl:block">
										<span v-if="!editMode && data.auditPrice != null">${{data.auditPrice}}</span>
										<InputNumber mode="decimal" :minFractionDigits="2" v-if="editMode" v-model="data.auditPrice"></InputNumber>
									</div>
									<div class="col-1 hidden xl:block">
										<span v-if="!editMode">{{data.councilCodes}}</span>
										<InputText v-if="editMode" v-model="data.councilCodes"></InputText>
									</div>
									<div class="text-center col-fixed" style="width:100px;">
										<i class="pi pi-check" v-if="!editMode && data.active" />
										<InputSwitch v-if="editMode" v-model="data.active"></InputSwitch>
									</div>
								</div>
								<!-- Second data item section description -->
								<div class="grid"  v-bind:class=" {childNode: data.parentServiceId !== null}" v-if="hasContent(data.description) || editMode">
									<!-- Ident second row -->
									<div class="col-2" style="text-align:left;" >
										<i class="pi pi-arrow-up mt-3" v-if="editMode" @click="moveService(data, true)" /><br />
										<i class="pi pi-arrow-down mt-3" v-if="editMode" @click="moveService(data, false)" />
									</div>
									<div class="col-10">
										<!-- Description -->
										<div class="notes-block">
											<div class="notes-block-label mr-4" v-if="hasContent(data.description) || editMode">Description</div>
											<div class="notes-block-content">
												<span v-if="!editMode">{{data.description}}</span>
												<TextArea v-if="editMode" v-model="data.description" rows="2" :autoResize="true" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
					</DataView>
				</div>
			</div>
		</div>
	</div>
	<Dialog v-model:visible="showAddService" style="max-width: 80%;" width="600px" :modal="true" class="p-fluid" v-bind:maximizable="true">
		<template #header>
			<h5>{{editServiceDialogHeader}}</h5>
		</template>
		<div class="new-service">
			<div class="col-12 property-service-item">
				<div class="grid flex">
					<div class="col-12 service-name compass-red">
						<span>Service name</span>
						<InputText v-model="selectedService.serviceName"></InputText>
					</div>
					<div class="col-12" v-tooltip="!canChangeParentStatus(selectedService) ? 'Status cannot be changed for parent services with children': ''">
						<span>Parent service</span>
						<Dropdown v-model="selectedService.parentServiceId"
								  :options="rootLevelServices"
								  optionLabel="serviceName"
								  optionValue="serviceId"
								  placeholder="Select a service (leave blank for root level)"
								  :filter="true"
								  :disabled="!canChangeParentStatus(selectedService)"
								  filterPlaceholder="Find a service"
								  @change="onParentChanged"
								  class="flex" />					
					</div>
				</div>
			</div>
		</div>
		<template v-if="!selectedService.serviceId" #footer>
			<Button class="cancel" icon="pi pi-times" label="Cancel" @click="showAddService = false" />
			<Button class="" icon="pi pi-check" label="Add" @click="addService" />
		</template>
		<template v-else #footer>
			<Button class="cancel" icon="pi pi-times" label="Cancel" @click="cancel" />
			<Button class="" icon="pi pi-check" label="Close" @click="showAddService = false" />
		</template>
	</Dialog>

	<Button class="sticky-button cancel" icon="pi pi-times" label="Cancel" @click="cancel" />
	<Button class="sticky-button" icon="pi pi-check" label="Save" @click="save" />
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { ServiceData, GetAllAccessibleServicesQuery } from '@/api-client/api-client'
	import filterListBySearchString from '@/utils/StringSearch'
	import { CompassApi } from '@/api-client/CompassApiProxy'
	import { format, isValid } from 'date-fns';
	import Toast from '@/utils/Toast';

	@Options({
		name: 'ServiceDefinitions',
		components: {
		},
		props: {
		},
		watch: {
			showAddService(_value: boolean) {
				this.clearAddServiceData();
			}
		}
	})
	export default class ServiceDefinitions extends Vue {
		serviceListFilter = "";
		selectedService: ServiceData = new ServiceData();
		services: ServiceData[] = [];
		serviceIntervalOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

		editMode = false;
		showAddService = false;
		activeServicesOnly = true;
		onlyServicesInUse = false;
		onlyParentServices = false;

		created() {
			this.loadServices();
		}

		// Computed
		get filteredServices() {
			let list = this.services;

			list = filterListBySearchString(list, this.serviceListFilter,
				(el) => el.serviceId
					+ ' ' + el.parentServiceId
					+ ' ' + el.serviceName
					+ ' ' + el.buildingAct
					+ ' ' + el.intervalMonths
					+ ' ' + el.fullServicePrice
					+ ' ' + el.auditPrice
					+ ' ' + el.councilCodes
					+ ' ' + el.description);

			return list;
		}

		// Computed isDesktop
		get isDesktop() {
			return window.innerWidth >= 992;
		}

		// Computed to simplify paginator on mobile
		get paginatorTemplate() {
			return this.isDesktop ?
				"CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				: "PrevPageLink NextPageLink"
		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'dd MMM yyyy');
		}

		hasContent(content: string): boolean {
			return content != null && content.length > 0 && content.trim().length > 0;
		}

		editModeChanged() {
			this.services.forEach(service => {
				if (service.description)
					service.description = service.description.trim();
			});
		}

		loadServices(){
			const apiClient = CompassApi.serviceApi(this.$store);

			const servicesQuery = new GetAllAccessibleServicesQuery();
			servicesQuery.sortType = 'default-sort'
			servicesQuery.onlyServicesInUse = this.onlyServicesInUse;
			servicesQuery.activeServicesOnly = this.activeServicesOnly;
			servicesQuery.onlyParentServices = this.onlyParentServices;

			apiClient.getAllServices(servicesQuery)
				.then(result => {
					this.services = result;
				})
				.catch(error => {
					Toast.ApiError('Error retrieving service definitions', error);
				});
		}

		addService() {
			if (!this.hasContentOrWhitespace(this.selectedService.serviceName)) {
				return;
			}

			this.selectedService.active = true;
			this.selectedService.whenCreated = new Date();

			// Child services have same Sort1 as parents
			if (this.selectedService.parentServiceId) {
				const parent = this.services.find(s => s.serviceId === this.selectedService.parentServiceId);
				if (parent) {
					this.selectedService.sort1 = parent.sort1;

					// Assign unique sort2
					this.selectedService.sort2 = this.getNextSort2ForParent(parent.serviceId!);
				}

				if (!parent) {
					Toast.Info('Parent not found', 'Parent could not be found, but parent service id is set');
					return;
				}
					
			// Assign unique sort 1
			} else {
				this.selectedService.sort1 = this.maxSort1 + 1;
			}

			this.services.unshift(this.selectedService);
			this.showAddService = false;
		}

		hasContentOrWhitespace(content?: string): boolean {
			return content != null && content.trim().length > 0;
		}

		save() {
			const apiClient = CompassApi.serviceApi(this.$store);
			apiClient.updateServiceDefinitions(this.services)
				.then(() => {
					Toast.Success('Updated sevices', 'Service definitions have been updated succesfully');
					this.showAddService = false;
					this.editMode = false;
					this.loadServices()
				})
				.catch(error => {
					Toast.ApiError('Error saving service definitions', error);
				});
		}

		cancel() {
			this.editMode = false;
			this.showAddService = false;
			this.loadServices();
		}

		clearAddServiceData() {
			if (!this.selectedService.serviceId || !this.showAddService) {
				this.selectedService = new ServiceData();
				this.selectedService.fullServicePrice = 0;
				this.selectedService.auditPrice = 0;
			}
		}

		serviceNameEdit(data: ServiceData) {
			this.selectedService = data;
			this.showAddService = true;
		}

		moveService(service: ServiceData, moveUp: boolean){
			if(service.parentServiceId){
				this.moveChildService(service, moveUp);
			} else{
				this.moveParentService(service, moveUp);
			}
		}

		moveParentService(service: ServiceData, moveUp: boolean){

			const orginalSort1 = service.sort1
			if(!orginalSort1)
				return;

			// Get new index
			const newSort1: number = moveUp ? orginalSort1 - 1 : orginalSort1 + 1;

			// Check if new sort1 is valid
			if(newSort1 < 1 || newSort1 > this.maxSort1)
				return;

			// get parent service to swap with
			const serviceToSwapOrder = this.services.find(
				_service => !_service.parentServiceId && _service.sort1 === newSort1)

			// Check there is a service to swap with
			if(!serviceToSwapOrder){
				Toast.Info('No service to swap with', 'No service to swap with');
				return;
			}

			// Swap sort orders
			for (const _service of this.services) {
				if (service.serviceId === _service.parentServiceId || service.serviceId === _service.serviceId) {
					_service.sort1 = newSort1;
				}

				if (serviceToSwapOrder.serviceId === _service.parentServiceId || serviceToSwapOrder.serviceId === _service.serviceId) {
					_service.sort1 = orginalSort1;
				}
			}

			this.services = [...this.services].sort((a, b) => (a.sort1 ?? 0) - (b.sort1 ?? 0));
		}

		moveChildService(service: ServiceData, moveUp: boolean){

			// Confirm is a child service
			const parentServiceId = service.parentServiceId;
			if(!parentServiceId)
				return;

			// Check valid sort2 is assigned
			const orginalSort2 = service.sort2;
			if(orginalSort2 == null)
				return;

			// Get new index
			const newSort2: number = moveUp ? orginalSort2 - 1 : orginalSort2 + 1;

			// get max sort number
			let maxSort2 = 0;
			for (const s of this.services) {
				if(!s || s.parentServiceId !== parentServiceId || s.sort2 == null)
					continue;

				if (s.sort2 > maxSort2) {
					maxSort2 = s.sort2;
				}
			}

			// Check if new sort2 is valid
			if(newSort2 < 1 || newSort2 > maxSort2)
				return;

			// get sibling service to swap with (same parent)
			const serviceToSwapOrder = this.services.find(
				_service => _service.parentServiceId === parentServiceId && _service.sort2 === newSort2)

			// Check there is a service to swap with
			if(!serviceToSwapOrder){
				Toast.Info('No service to swap with', 'No service to swap with');
				return;
			}

			// Swap sort orders
			for (const _service of this.services) {

				// moved child
				if (service.serviceId === _service.parentServiceId || service.serviceId === _service.serviceId) {
					_service.sort2 = newSort2;
				}

				// swapped-with child
				if (serviceToSwapOrder.serviceId === _service.parentServiceId || serviceToSwapOrder.serviceId === _service.serviceId) {
					_service.sort2 = orginalSort2;
				}
			}

			this.services = [...this.services].sort((a, b) => {

				// Parents: sort by sort1
				if(!a.parentServiceId && !b.parentServiceId){
					return (a.sort1 ?? 0) - (b.sort1 ?? 0);
				}

				// Children: sort by sort2 (ONLY within same parent)
				if(a.parentServiceId && b.parentServiceId){
					if(a.parentServiceId !== b.parentServiceId)
						return (a.parentServiceId ?? 0) - (b.parentServiceId ?? 0);

					return (a.sort2 ?? 0) - (b.sort2 ?? 0);
				}

				// Parent should come before its children
				if(!a.parentServiceId && b.parentServiceId){
					return a.serviceId === b.parentServiceId ? -1 : (a.sort1 ?? 0) - ((b.sort1 ?? 0));
				}

				if(a.parentServiceId && !b.parentServiceId){
					return b.serviceId === a.parentServiceId ? 1 : ((a.sort1 ?? 0)) - (b.sort1 ?? 0);
				}

				return 0;
			});
		}

		onParentChanged(e: any) {
			const newParentId = (e?.value ?? this.selectedService.parentServiceId) as number | null;

			if (newParentId == null) {
				this.selectedService.parentServiceId = undefined;
				this.selectedService.sort2 = undefined;
				this.selectedService.sort1 = this.maxSort1 + 1;
				return;
			}

			const parent = this.services.find(service => service.serviceId === newParentId);
			if (!parent) return;

			this.selectedService.sort1 = parent.sort1;
			this.selectedService.sort2 = this.getNextSort2ForParent(newParentId);
		}

		getNextSort2ForParent(parentServiceId: number): number {
			const serviceSort2Set = new Set<number>();

			for (const service of this.services) {
				if (service?.parentServiceId !== parentServiceId) continue;

				const sort2 = service.sort2;
				if (sort2 == null) continue;

				serviceSort2Set.add(sort2);
			}

			let count = 1;
			while (serviceSort2Set.has(count)) count++;
			return count;
		}

		canChangeParentStatus(service: ServiceData): boolean {
			if (!service || !service.serviceId) return true;

			return !this.services.some(
				s => s.parentServiceId === service.serviceId
			);
		}

		// Include blank option if no parent service (e.g is parent service)
		get rootLevelServices() {
			return [
				{
					serviceId: null,
					serviceName: "(leave blank for root level)"
				},
				...this.services.filter(service => service.parentServiceId == null
					&& service.serviceId !== this.selectedService.serviceId)
			];
		}

		get editServiceDialogHeader() {
			return this.selectedService.serviceId ? "Edit Service Definition" : "Add New Service Type";
		}

		get maxSort1(): number {
			let maxSort1 = 0;

			for (const service of this.services) {
				if (!service || service.sort1 == null)
					continue;

				if (service.sort1 > maxSort1) {
					maxSort1 = service.sort1;
				}
			}

			return maxSort1;
		}
	}
</script>

<style scoped lang="scss">
	.property-service-table {
		font-size: 15px;
	}

	.property-service-item {
		padding-left: 4px;
		padding-right: 3px;
		padding-top: 2px;
		margin-bottom: 6px;
		&:nth-child(even) {
			background-color: rgb(248, 249, 250);
			border-bottom: 1px solid #ccc;
			}

		.notes-block {
			padding: 5px;
			margin-right: 3px;
			display: flex;
		}

		.notes-block-label {
			min-width: 65px;
			max-width: 65px;
			font-size: 13px;
			text-align: left;
			padding-left: 2px;
			padding-right: 4px;
		}

		.notes-block-content {
			white-space: pre-wrap;
			width: 100%;
		}

		.service-name {
			font-weight: 700;
			align-self: end; // So that it vertically aligns at the bottom when the larger text boxes are visible in edit mode
		}

		.childNode {
			padding-left: 20px;
			border-left: 1px solid #ccc;
		}

		.parentNode {
			margin-left: 2px; // to align as child element border takes 2px
			padding-left: 0px;
		}
	}
</style>